import React from "react";
import { Link } from "react-router-dom";

const ButtonLink = ({
  title,
  url,
  hasArrow = true,
  withDropShadow = true,
  isExternalLink = false,
  ...props
}) => {
  return (
    <>
      {isExternalLink ? (
        <a
          target={"_blank"}
          rel="noopener noreferrer"
          href={url}
          className={`custom-btn ${
            withDropShadow ? "custom-btn-with-shadow" : ""
          }  text-white bg-secondary pl-6 lg:pl-8 py-4 text-center rounded-lg mr-6 text-sm md:text-base  inline-flex items-center font-medium focus:outline-none mb-4`}
          {...props}
        >
          {title}
          {hasArrow && (
            <span className="pl-4 pr-4 lg:pr-6">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5625 7.30121C12.8699 6.99382 12.8699 6.49544 12.5625 6.18805L7.5533 1.17884C7.24591 0.871448 6.74753 0.871448 6.44014 1.17884C6.13275 1.48623 6.13275 1.98461 6.44014 2.292L10.8928 6.74463L6.44014 11.1973C6.13275 11.5047 6.13275 12.003 6.44014 12.3104C6.74753 12.6178 7.24591 12.6178 7.5533 12.3104L12.5625 7.30121ZM0.902344 7.53175H12.0059V5.95751H0.902344V7.53175Z"
                  fill="white"
                />
              </svg>
            </span>
          )}
        </a>
      ) : (
        <Link
          to={url}
          className={`custom-btn ${
            withDropShadow ? "custom-btn-with-shadow" : ""
          }  text-white bg-secondary pl-6 lg:pl-8 py-4 text-center rounded-lg mr-6 text-sm md:text-base  inline-flex items-center font-medium focus:outline-none mb-4`}
          {...props}
        >
          {title}
          {hasArrow && (
            <span className="pl-4 pr-4 lg:pr-6">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5625 7.30121C12.8699 6.99382 12.8699 6.49544 12.5625 6.18805L7.5533 1.17884C7.24591 0.871448 6.74753 0.871448 6.44014 1.17884C6.13275 1.48623 6.13275 1.98461 6.44014 2.292L10.8928 6.74463L6.44014 11.1973C6.13275 11.5047 6.13275 12.003 6.44014 12.3104C6.74753 12.6178 7.24591 12.6178 7.5533 12.3104L12.5625 7.30121ZM0.902344 7.53175H12.0059V5.95751H0.902344V7.53175Z"
                  fill="white"
                />
              </svg>
            </span>
          )}
        </Link>
      )}
    </>
  );
};

export default ButtonLink;
